<template>
  <div
    class="welcome-container flex h-screen items-center object-fill p-10 md:p-5"
  >
    <div
      class="max-h-welcome-container m-auto flex h-full max-w-sm flex-col justify-between"
    >
      <div class="mb-5 flex justify-center">
        <img
          v-if="brokerLogo"
          class="broker-logo"
          :src="brokerLogo"
          alt="broker logo"
        />
      </div>
      <div class="mb-4 flex flex-col justify-start lg:mb-8">
        <small class="mb-4 text-left text-2xs font-semibold text-dark-blue">
          WELCOME TO
        </small>
        <img
          src="@/assets/highway_logo.svg"
          alt="highway-logo"
          class="w-3/5 md:w-1/2 lg:w-3/5"
        />
      </div>
      <p class="mb-0 text-left text-1md text-dark-blue md:mb-6">
        Let's get you onboarded with {{ brokerName ? brokerName : 'Highway' }}.
      </p>
      <div>
        <informative-item
          v-for="(item, index) of informative_items"
          :key="index"
          :title="item.title"
          :subtitle="item.subtitle"
          :image="item.image"
        />
      </div>
      <div class="flex flex-col items-center justify-between">
        <ButtonComponent
          variant="primary"
          class="h-12 w-full font-normal text-white"
          @click="handleClick"
        >
          Get Started
        </ButtonComponent>
        <div class="mt-4 flex flex-col items-center justify-center">
          <samll class="text-1md text-base text-dark-blue">
            Already have an account?
          </samll>
          <router-link
            to="/sign-up/create-account"
            class="w-max text-1md text-yellow-500"
            @click="setIsLogin(true)"
          >
            Log in
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ButtonComponent, InformativeItem } from '@/components';

export default {
  name: 'Welcome',
  components: {
    ButtonComponent,
    InformativeItem,
  },
  data() {
    return {
      isLoading: false,
      informative_items: [
        {
          title: 'fast',
          subtitle: 'Create a core profile faster than ever',
        },
        {
          title: 'efficient',
          subtitle: 'Never re-enter your details again',
        },
        {
          title: 'portable',
          subtitle: 'Use your profile with other Brokers',
        },
        {
          title: 'secure',
          subtitle: 'Keep your company identity safe',
        },
        {
          title: 'free',
          subtitle: 'Do it all for no charge',
        },
      ],
    };
  },
  computed: {
    brokerName() {
      return this.$store.state.brokers?.logo?.legal_name || null;
    },
    brokerLogo() {
      return this.$store.state.brokers?.logo?.url || null;
    },
  },
  async created() {
    const clientId = localStorage.getItem('client_id');

    const redirectUrl =
      JSON.parse(localStorage.getItem('redirect_url_after_sigin')) || {};
    const companyId = redirectUrl?.query?.company_id;

    if (companyId) {
      await this.$store.dispatch('brokers/getLogoByCompanyId', companyId);
    } else if (clientId) {
      await this.$store.dispatch(
        'brokers/getLogoByClientId',
        clientId.toString()
      );
    }
  },
  methods: {
    async handleClick() {
      this.isLoading = true;
      await this.$store.commit('setIsLogin', false);
      await this.$router.push({
        name: 'CarrierDetails',
        params: { canMoveOn: true },
      });
      this.isLoading = false;
    },
    async setIsLogin(bool) {
      await this.$store.commit('setIsLogin', bool);
    },
  },
};
</script>

<style>
.welcome-container {
  background-image:
    url('@/assets/highway-h.svg'),
    linear-gradient(
      218.91deg,
      rgba(96, 95, 128, 0.3) -91.54%,
      rgba(96, 95, 128, 0) 85.24%
    );
  /* background-image: url("@/assets/highway-h.svg"); */
  background-size: cover;
  background-position-x: center;
  background-position-y: 100%;
}

@media (min-width: 1024px) {
  .welcome-container {
    background-image:
      url('@/assets/highway-h.svg'),
      linear-gradient(
        218.91deg,
        rgba(96, 95, 128, 0.3) -91.54%,
        rgba(96, 95, 128, 0) 85.24%
      );
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
}

.max-h-welcome-container {
  max-height: 39rem;
}

.broker-logo {
  margin: 0 auto;
  margin-bottom: 1.25rem;
  max-width: 60%;
  max-height: 60px;
}
</style>
